<template>
  <div>
    <ul class="top-info">
      <li class="text">
        <p class="title">1:1 문의하기</p>
        <p>전남드래곤즈에 1:1 문의하기입니다.</p>
      </li>
    </ul>
    <div class="contact-us-write">
      <p class="title">1:1 문의하기 내역</p>
      <textarea class="text-area" placeholder="내용을 입력해 주세요." v-model="question">

      </textarea>
      <button class="login-btn" @click="submit">작성하기</button>
    </div>
  </div>
</template>

<script>
import {trim, isEmpty} from "@/lib";

export default {
  name: 'ContactUsWrite',
  data() {
    return {
      tabList: [],
      question: '',
      loading: false
    }
  },
  mounted () {
  },
  methods: {
    async submit() {
      if(this.loading) return;
      if( isEmpty(trim(this.question)) ) {
        alert('내용을 입력해 주세요.')
        return;
      }

      if(confirm('등록하시겠습니까?')) {
        this.loading = true;
        const {data} = await this.$http.post('/notice/qna', {question: this.question})
        if(data.success) {
          alert('1:1 문의가 등록되었습니다.');
          this.$router.push({name: 'contactUs'});
        } else {
          alert('잠시 후 다시 시도해 주세요.');
        }
        this.loading = false;
      }
    }
  }
}
</script>
